export const usePeakDailyVisitors = () => ({ data: { peak_count: 0, date: null as string | null }, isLoading: false });
